"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7779],{

/***/ 97779:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ CarouselSection_CarouselCards; }
});

// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks/es/core/Box/Box.mjs
var Box = __webpack_require__(8013);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks/es/core/Flex/Flex.mjs
var Flex = __webpack_require__(93298);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks/es/core/Button/Button.mjs
var Button = __webpack_require__(26029);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks/es/core/Icon/Icon.mjs + 1 modules
var Icon = __webpack_require__(49154);
// EXTERNAL MODULE: ./src/components/landing-pages-v2/shared/Typography.tsx
var Typography = __webpack_require__(78837);
// EXTERNAL MODULE: ./src/components/landing-pages-v2/Grid.tsx
var Grid = __webpack_require__(74263);
// EXTERNAL MODULE: ./node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(70917);
;// CONCATENATED MODULE: ./src/components/landing-pages-v2/CarouselSection/CarouselAnimations.ts

var ANIMATION_DURATION = 0.7;
var disappearAnimationKeyframes = /*#__PURE__*/ (0,emotion_react_browser_esm/* keyframes */.F4)("from{transform:scale(100%);opacity:1;}to{transform:scale(80%);opacity:0;}");
var disappearAnimation = /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)({
    animation: "".concat(disappearAnimationKeyframes, " ").concat(ANIMATION_DURATION, "s")
});
var reverseDisappearAnimationKeyframes = /*#__PURE__*/ (0,emotion_react_browser_esm/* keyframes */.F4)("from{transform:scale(80%);opacity:0;}to{transform:scale(100%);opacity:1;}");
var reverseDisappearAnimation = /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)({
    animation: "".concat(reverseDisappearAnimationKeyframes, " ").concat(ANIMATION_DURATION, "s")
});
var slideAnimationKeyFrames = /*#__PURE__*/ (0,emotion_react_browser_esm/* keyframes */.F4)("0%{transform:translateX(0%);}100%{transform:translateX(-105%);}");
var slideAnimation = /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)({
    animation: "".concat(slideAnimationKeyFrames, " ").concat(ANIMATION_DURATION, "s"),
    willChange: "transform"
});
var reverseSlideAnimationKeyFrames = /*#__PURE__*/ (0,emotion_react_browser_esm/* keyframes */.F4)("0%{transform:translateX(-105%);}100%{transform:translateX(0%);}");
var reverseSlideAnimation = /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)({
    animation: "".concat(reverseSlideAnimationKeyFrames, " ").concat(ANIMATION_DURATION, "s"),
    willChange: "transform"
});

// EXTERNAL MODULE: ./node_modules/react-lazyload/lib/index.js
var lib = __webpack_require__(1216);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks/es/core/Card/Card.mjs
var Card = __webpack_require__(63282);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks/es/core/Text/Text.mjs
var Text = __webpack_require__(4796);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks/es/core/Link/Link.mjs
var Link = __webpack_require__(47208);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks/es/theme/novo/index.mjs + 35 modules
var novo = __webpack_require__(40994);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks/es/theme/novo/foundations/breakpoints.mjs
var breakpoints = __webpack_require__(40156);
// EXTERNAL MODULE: ./src/components/globals.ts
var globals = __webpack_require__(35480);
// EXTERNAL MODULE: ./src/components/shared/performance/pictures.tsx
var pictures = __webpack_require__(29212);
;// CONCATENATED MODULE: ./src/components/landing-pages-v2/CarouselSection/ReviewCard.tsx








var SPACER = 6;
var BROWN95 = "#F6F5F4";
var PICTURE_SIZES = [
    {
        minWidth: breakpoints/* breakpoints.0 */.AV[0],
        maxWidth: breakpoints/* breakpoints.1 */.AV[1],
        preset: "square-256"
    },
    {
        minWidth: breakpoints/* breakpoints.1 */.AV[1],
        maxWidth: breakpoints/* breakpoints.2 */.AV[2],
        preset: "square-512"
    },
    {
        minWidth: breakpoints/* breakpoints.2 */.AV[2],
        maxWidth: breakpoints/* breakpoints.3 */.AV[3],
        preset: "square-512"
    },
    {
        minWidth: breakpoints/* breakpoints.3 */.AV[3],
        maxWidth: null,
        preset: "square-1024"
    }, 
];
/* storybook-check-ignore */ var ReviewCard = function(param) {
    var image = param.image, quote = param.quote, analyticsName = param.analyticsName, link = param.link, name = param.name, market = param.market;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Card/* default */.C, {
        variant: "primary",
        minHeight: [
            "460",
            null,
            "500",
            null,
            null
        ],
        maxHeight: [
            null,
            null,
            "500",
            null,
            null
        ],
        minWidth: [
            "264",
            "319",
            "378",
            null,
            null
        ],
        maxWidth: [
            null,
            null,
            "378",
            null,
            null
        ],
        style: {
            backgroundColor: BROWN95,
            borderRadius: "36px",
            boxShadow: novo/* novo.shadows.none */.hI.shadows.none
        },
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Flex/* default */.Z, {
                flexDirection: "column",
                textAlign: "center",
                alignItems: "center",
                gap: SPACER,
                flexGrow: 1,
                mt: SPACER,
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* default */.Z, {
                        width: [
                            "80px",
                            null,
                            "112px"
                        ],
                        height: [
                            "80px",
                            null,
                            "112px"
                        ],
                        borderRadius: "rounded",
                        overflow: "hidden",
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(lib/* default */.ZP, {
                            offset: globals/* LAZY_LOAD_OFFSET */.eH,
                            children: (0,pictures/* generatePresetPictureSet */.eY)({
                                photoUrl: image,
                                sizes: PICTURE_SIZES,
                                debugImageSizes: false,
                                radii: {},
                                lazy: true
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* default */.Z, {
                        size: "110",
                        fontWeight: "regular",
                        style: {
                            lineHeight: "25.6px"
                        },
                        minWidth: [
                            null,
                            null,
                            null,
                            "250px"
                        ],
                        children: quote
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Link/* default */.Z, {
                        href: link,
                        "aria-label": analyticsName,
                        analyticsName: analyticsName,
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* default */.Z, {
                            fontWeight: "medium",
                            size: "110",
                            color: "brand50",
                            children: "Read more"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Flex/* default */.Z, {
                flexDirection: "column",
                textAlign: "center",
                marginBottom: SPACER,
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* default */.Z, {
                        size: "120",
                        fontWeight: "medium",
                        margin: 0,
                        children: name
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* default */.Z, {
                        size: "100",
                        fontWeight: "medium",
                        color: "neutrals70",
                        margin: 0,
                        children: market
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/landing-pages-v2/CarouselSection/CarouselCards.tsx







var CARD_GAP = [
    5,
    null,
    6,
    null,
    null
];
var TITLE_MARGIN_LEFT = [
    6,
    null,
    9,
    11,
    null
];
var CAROUSEL_MARGIN_LEFT = [
    6,
    null,
    9,
    11,
    12
];
var TITLE_TO_CAROUSEL_PADDING = [
    11,
    null,
    null,
    0,
    null
];
var TITLE_TO_BUTTONS_PADDING = [
    null,
    null,
    null,
    11,
    null
];
var RenderCarouselCards = function(entry) {
    // Contentful Data
    var fields = entry.fields, sys = entry.sys;
    var locale = sys.locale;
    var reviews = (fields === null || fields === void 0 ? void 0 : fields.reviews) || [];
    // Scrolling logic
    var ref = (0,react.useState)(false), animate = ref[0], setAnimate = ref[1];
    var ref1 = (0,react.useState)(0), numHiddenCards = ref1[0], setNumHiddenCards = ref1[1];
    var ref2 = (0,react.useState)(null), scrollDirection = ref2[0], setScrollDirection = ref2[1];
    var scrollCards = function(direction) {
        setAnimate(true);
        setScrollDirection(direction);
        if (direction === "prev") {
            setNumHiddenCards(Math.max(numHiddenCards - 1, 0));
        }
        // Timeout has to match duration on animation CSS
        setTimeout(function() {
            setAnimate(false);
            if (direction === "next") {
                setNumHiddenCards(Math.min(numHiddenCards + 1, reviews.length - 1));
            }
            setScrollDirection(null);
        }, ANIMATION_DURATION * 1000);
    };
    var getAnimation = function(cardIdx) {
        if (cardIdx == 0) {
            return scrollDirection === "next" ? disappearAnimation : reverseDisappearAnimation;
        }
        return scrollDirection === "next" ? slideAnimation : reverseSlideAnimation;
    };
    if (locale === "es") return;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* default */.Z, {
        analyticsName: "cosmos-landing-page-carousel-cards-".concat(fields === null || fields === void 0 ? void 0 : fields.analyticsId),
        trackImpression: true,
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Grid/* default */.Z, {
            backgroundColor: "neutrals0",
            py: [
                12,
                null,
                null,
                "160",
                null
            ],
            horizontalMargin: false,
            maxHeight: [
                null,
                null,
                null,
                "820"
            ],
            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Flex/* default */.Z, {
                gridColumn: Grid/* gridStyles.colSpan12 */.m.colSpan12,
                flexDirection: [
                    "column",
                    null,
                    null,
                    "row",
                    null
                ],
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Flex/* default */.Z, {
                        flexDirection: [
                            null,
                            null,
                            "row",
                            "column",
                            null
                        ],
                        justifyContent: [
                            "flex-start",
                            null,
                            null,
                            "center"
                        ],
                        ml: TITLE_MARGIN_LEFT,
                        paddingBottom: TITLE_TO_CAROUSEL_PADDING,
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Flex/* default */.Z, {
                                flexGrow: [
                                    null,
                                    null,
                                    1,
                                    "unset",
                                    null
                                ],
                                paddingBottom: TITLE_TO_BUTTONS_PADDING,
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* default */.Z, {
                                    minWidth: [
                                        "257",
                                        "324",
                                        "".concat(fields === null || fields === void 0 ? void 0 : fields.titleWidthTablet),
                                        "464",
                                        null
                                    ],
                                    maxWidth: [
                                        "257",
                                        "324",
                                        "".concat(fields === null || fields === void 0 ? void 0 : fields.titleWidthTablet),
                                        "464",
                                        null
                                    ],
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Typography/* TitleWithAccent */.aI, {
                                        title: fields.title,
                                        titleAccent: fields.secondaryTitle,
                                        titleColor: "$backgroundAccentBrand",
                                        titleAccentColor: "$contentPrimary"
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Flex/* default */.Z, {
                                display: [
                                    "none",
                                    "none",
                                    "none",
                                    "none",
                                    "block"
                                ],
                                mr: TITLE_MARGIN_LEFT,
                                flexDirection: "column",
                                justifyContent: [
                                    null,
                                    null,
                                    "flex-end",
                                    "unset",
                                    "unset"
                                ],
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Flex/* default */.Z, {
                                    flexDirection: "row",
                                    children: [
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Button/* default */.ZP, {
                                            variant: "icon",
                                            mr: 5,
                                            onClick: function() {
                                                return scrollCards("prev");
                                            },
                                            disabled: animate || numHiddenCards == 0,
                                            "aria-label": "View previous review",
                                            analyticsName: "cosmos-landing-page-carousel-cards-previous-".concat(fields === null || fields === void 0 ? void 0 : fields.analyticsId),
                                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Icon/* default */.Z, {
                                                name: "arrow-left",
                                                size: 24
                                            })
                                        }),
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Button/* default */.ZP, {
                                            variant: "icon",
                                            onClick: function() {
                                                return scrollCards("next");
                                            },
                                            disabled: animate || numHiddenCards == reviews.length - 1,
                                            "aria-label": "View next review",
                                            analyticsName: "cosmos-landing-page-carousel-cards-next-".concat(fields === null || fields === void 0 ? void 0 : fields.analyticsId),
                                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Icon/* default */.Z, {
                                                name: "arrow-right",
                                                size: 24
                                            })
                                        })
                                    ]
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Flex/* default */.Z, {
                        overflowX: [
                            "auto",
                            null,
                            "hidden"
                        ],
                        // hide scrollbar
                        css: {
                            "&::-webkit-scrollbar": {
                                width: 0
                            }
                        },
                        scrollSnapType: [
                            "inline mandatory",
                            null,
                            "unset"
                        ],
                        overscrollBehaviorX: "contain",
                        scrollPaddingLeft: [
                            6,
                            6,
                            9,
                            0
                        ],
                        pr: [
                            6,
                            6,
                            9,
                            0
                        ],
                        width: "100%",
                        children: reviews.map(function(review, idx) {
                            var ref, ref1, ref2, ref3, ref4;
                            var reviewName = "hp-customer-review-".concat(idx);
                            var visibleCardIdx = idx - numHiddenCards;
                            return visibleCardIdx >= 0 && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Flex/* default */.Z, {
                                scrollSnapAlign: "start",
                                ml: visibleCardIdx == 0 ? CAROUSEL_MARGIN_LEFT : CARD_GAP,
                                css: animate ? getAnimation(visibleCardIdx) : null,
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ReviewCard, {
                                    image: review === null || review === void 0 ? void 0 : (ref = review.fields) === null || ref === void 0 ? void 0 : ref.image,
                                    quote: review === null || review === void 0 ? void 0 : (ref1 = review.fields) === null || ref1 === void 0 ? void 0 : ref1.reviewerQuote,
                                    link: review === null || review === void 0 ? void 0 : (ref2 = review.fields) === null || ref2 === void 0 ? void 0 : ref2.reviewLink,
                                    name: review === null || review === void 0 ? void 0 : (ref3 = review.fields) === null || ref3 === void 0 ? void 0 : ref3.reviewerName,
                                    market: review === null || review === void 0 ? void 0 : (ref4 = review.fields) === null || ref4 === void 0 ? void 0 : ref4.reviewerMarket,
                                    analyticsName: "cosmos-landing-page-review-".concat(fields === null || fields === void 0 ? void 0 : fields.analyticsId, "-").concat(reviewName)
                                }, reviewName)
                            }, reviewName);
                        })
                    })
                ]
            })
        })
    });
};
var CarouselCards = {
    render: RenderCarouselCards
};
/* harmony default export */ var CarouselSection_CarouselCards = (CarouselCards);


/***/ }),

/***/ 74263:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "m": function() { return /* binding */ gridStyles; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(99534);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(35944);
/* harmony import */ var _opendoor_bricks_core__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(93298);
/* harmony import */ var _opendoor_bricks_core__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(8013);
/* storybook-check-ignore */ 




var gridStyles = {
    margin: [
        6,
        6,
        9,
        11,
        11
    ],
    colSpan12: "span 12 / span 12"
};
function Grid(_param) {
    var backgroundColor = _param.backgroundColor, children = _param.children, _verticalMargin = _param.verticalMargin, verticalMargin = _verticalMargin === void 0 ? false : _verticalMargin, _horizontalMargin = _param.horizontalMargin, horizontalMargin = _horizontalMargin === void 0 ? true : _horizontalMargin, maxWidth = _param.maxWidth, mr = _param.mr, ml = _param.ml, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_param, [
        "backgroundColor",
        "children",
        "verticalMargin",
        "horizontalMargin",
        "maxWidth",
        "mr",
        "ml"
    ]);
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)(_opendoor_bricks_core__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        width: "100%",
        justifyContent: "center"
    }, props), {
        backgroundColor: backgroundColor,
        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)(_opendoor_bricks_core__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
            width: "100%",
            maxWidth: maxWidth || "1440px",
            children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)(_opendoor_bricks_core__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                gridTemplateColumns: "repeat(12, minmax(0, 1fr))",
                display: "grid",
                columnGap: [
                    0,
                    5,
                    6
                ],
                my: verticalMargin ? gridStyles.margin : undefined,
                width: "100%",
                mr: mr || (horizontalMargin ? gridStyles.margin : undefined),
                ml: ml || (horizontalMargin ? gridStyles.margin : undefined),
                children: children
            })
        })
    }));
}
/* harmony default export */ __webpack_exports__["Z"] = (Grid);


/***/ }),

/***/ 63282:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

/* unused harmony export Card */
/* harmony import */ var core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(82526);
/* harmony import */ var core_js_modules_es_symbol_description_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41817);
/* harmony import */ var core_js_modules_es_symbol_iterator_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(32165);
/* harmony import */ var core_js_modules_es_symbol_to_primitive_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(96649);
/* harmony import */ var core_js_modules_es_array_filter_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(57327);
/* harmony import */ var core_js_modules_es_array_for_each_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(89554);
/* harmony import */ var core_js_modules_es_array_index_of_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(82772);
/* harmony import */ var core_js_modules_es_array_iterator_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(66992);
/* harmony import */ var core_js_modules_es_date_to_primitive_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(96078);
/* harmony import */ var core_js_modules_es_number_constructor_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(9653);
/* harmony import */ var core_js_modules_es_object_assign_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(19601);
/* harmony import */ var core_js_modules_es_object_define_properties_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(33321);
/* harmony import */ var core_js_modules_es_object_define_property_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(69070);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(38880);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(49337);
/* harmony import */ var core_js_modules_es_object_keys_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(47941);
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(41539);
/* harmony import */ var core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(78783);
/* harmony import */ var core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(54747);
/* harmony import */ var core_js_modules_web_dom_collections_iterator_js__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(33948);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(67294);
/* harmony import */ var _hooks_useObservabilitySafe_mjs__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(98352);
/* harmony import */ var _system_utils_index_mjs__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(48189);
/* harmony import */ var _Flex_index_mjs__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(93298);
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }




















var _excluded = ["analyticsName", "trackImpression", "cardStyle"],
  _excluded2 = ["variant", "clickable", "analyticsName"];
function cov_gid0f43ak() {
  var path = "/__w/code/code/js/packages/bricks/src/core/Card/Card.tsx";
  var hash = "2c75e8ea7c98a5ebfcfd3636399d3e855efcc67b";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/core/Card/Card.tsx",
    statementMap: {
      "0": {
        start: {
          line: 38,
          column: 81
        },
        end: {
          line: 53,
          column: 1
        }
      },
      "1": {
        start: {
          line: 44,
          column: 20
        },
        end: {
          line: 44,
          column: 92
        }
      },
      "2": {
        start: {
          line: 45,
          column: 2
        },
        end: {
          line: 52,
          column: 4
        }
      },
      "3": {
        start: {
          line: 130,
          column: 41
        },
        end: {
          line: 142,
          column: 1
        }
      },
      "4": {
        start: {
          line: 131,
          column: 16
        },
        end: {
          line: 131,
          column: 72
        }
      },
      "5": {
        start: {
          line: 132,
          column: 2
        },
        end: {
          line: 134,
          column: 3
        }
      },
      "6": {
        start: {
          line: 133,
          column: 4
        },
        end: {
          line: 133,
          column: 91
        }
      },
      "7": {
        start: {
          line: 135,
          column: 2
        },
        end: {
          line: 141,
          column: 4
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 38,
            column: 81
          },
          end: {
            line: 38,
            column: 82
          }
        },
        loc: {
          start: {
            line: 43,
            column: 6
          },
          end: {
            line: 53,
            column: 1
          }
        },
        line: 43
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 130,
            column: 41
          },
          end: {
            line: 130,
            column: 42
          }
        },
        loc: {
          start: {
            line: 130,
            column: 94
          },
          end: {
            line: 142,
            column: 1
          }
        },
        line: 130
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 132,
            column: 2
          },
          end: {
            line: 134,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 132,
            column: 2
          },
          end: {
            line: 134,
            column: 3
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 132
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0
    },
    f: {
      "0": 0,
      "1": 0
    },
    b: {
      "0": [0, 0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "2c75e8ea7c98a5ebfcfd3636399d3e855efcc67b"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_gid0f43ak = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_gid0f43ak();
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }





/**
 * NOTE ABOUT METRIC TRACKING:
 * Card is set up to track impression events
 * It will only track impression events if:
 *  1) a non-empty analyticsName is passed down - Convention: {appName}-{cardName}
 *  2) card enters viewport (threshold is set at 100% for now.  threshold: Number between 0 and 1 indicates the percentage that should be visible before triggering.)
 *
 * Events will be sent to the journey service and will end up in the corresponding tables (e.g. journey_service_production.card_view_event for card impression events)
 * For more information on tracking please refer here: https://opendoor.atlassian.net/wiki/spaces/SELL/pages/1926201404/EDD+User+Behavior+Metrics+in+Bricks
 */
cov_gid0f43ak().s[0]++;
var CardWithTracking = function CardWithTracking(_ref) {
  var analyticsName = _ref.analyticsName,
    trackImpression = _ref.trackImpression,
    cardStyle = _ref.cardStyle,
    props = _objectWithoutProperties(_ref, _excluded);
  cov_gid0f43ak().f[0]++;
  var inViewRef = (cov_gid0f43ak().s[1]++, (0,_hooks_useObservabilitySafe_mjs__WEBPACK_IMPORTED_MODULE_21__/* .useTrackComponentInView */ .O)('cardViewEvent', trackImpression, analyticsName));
  cov_gid0f43ak().s[2]++;
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_20__.createElement(_Flex_index_mjs__WEBPACK_IMPORTED_MODULE_22__/* ["default"] */ .Z
  // __css has a lower priority than sx
  , _extends({
    ref: inViewRef,
    __css: cardStyle
  }, props));
};

/**
 * Cards are containers that are used to bring attention to an action that we
 * want the seller or buyer to take.  We have `Primary`, `Secondary`,
 * `Tertiary`, and `Outline` Cards with different use cases.
 *
 * *   `Primary` Cards should be used only once per page.
 *
 * *   `Secondary` Cards can be used more than once on a page.
 *
 * *   `Tertiary` Cards are used for content groupings and content callouts.
 *
 * *   `Outline` Cards may be used as an alternative to `Tertiary`.
 *
 *
 * Card variant variations
 * ------------------------------------------------------------------------------------------------
 *
 * "primary"
 *
 * "secondary"
 *
 * "tertiary"
 *
 * "outline"
 *
 * Accessibility
 *
 *
 * -----------------
 *
 * ####
 *
 * Clickable Cards
 *
 * Non-interactable elements should not have an `onClick` method. When an
 * element should be clickable, it should be wrapped in a `Button` component
 * with the `ghost` variant. This will ensure that the element is clickable and
 * has a hover state without adding interactive behaviors to the element.
 *
 * ###
 *
 * ✅ Pass
 *
 * <Button variant="ghost" onClick={() => {/* do something *&#47; }}
 * aria-label=""> <Card /> </Button>
 *
 *
 * ###
 *
 * 🛑 Fail
 *
 * <Card onClick={() => {/* do something *&#47; }} />
 *
 *
 * Analytics
 *
 *
 * -------------
 *
 * `Card` is set up to track impression events. It will only track impression
 * events if:
 *
 * 1.  a non-empty `analyticsName` is passed down (convention:
 * {appName}-{cardName})
 *
 * 2.  passing `trackImpression={true}` Card impression events will only be
 * tracked the first time that the card enters the viewport
 *
 *
 * Events will be sent to the journey service and will end up in the
 * corresponding tables (e.g.
 * journey\_service\_production.platform\_card\_view\_event for card impression
 * events). For more information on tracking please refer
 * here:[https://opendoor.atlassian.net/wiki/spaces/CONSUMER/blog/2023/05/10/2304737293/Bricks+Events+Update](https://opendoor.atlassian.net/wiki/spaces/CONSUMER/blog/2023/05/10/2304737293/Bricks+Events+Update)
 */
cov_gid0f43ak().s[3]++;
var Card = function Card(_ref2) {
  var variant = _ref2.variant,
    clickable = _ref2.clickable,
    analyticsName = _ref2.analyticsName,
    props = _objectWithoutProperties(_ref2, _excluded2);
  cov_gid0f43ak().f[1]++;
  var style = (cov_gid0f43ak().s[4]++, (0,_system_utils_index_mjs__WEBPACK_IMPORTED_MODULE_23__/* .useStyleConfig */ .mq)('Card', _objectSpread({
    variant: variant,
    clickable: clickable
  }, props)));
  cov_gid0f43ak().s[5]++;
  if (analyticsName) {
    cov_gid0f43ak().b[0][0]++;
    cov_gid0f43ak().s[6]++;
    return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_20__.createElement(CardWithTracking, _extends({
      cardStyle: style,
      analyticsName: analyticsName
    }, props));
  } else {
    cov_gid0f43ak().b[0][1]++;
  }
  cov_gid0f43ak().s[7]++;
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_20__.createElement(_Flex_index_mjs__WEBPACK_IMPORTED_MODULE_22__/* ["default"] */ .Z
  // __css has a lower priority than sx
  , _extends({
    __css: style
  }, props));
};
/* harmony default export */ __webpack_exports__["C"] = (Card);

/***/ })

}]);